export default __webpack_public_path__ + "static/media/rate-black.593d8a95.svg";